import { combineReducers } from 'redux';
import { reducer as formReducer } from 'redux-form';
import { connectRouter } from 'connected-react-router'
import main from './main';
// import sidebar from './sidebarReducer';
import notifications from './notificationsReducer';
// import popup from './popup';

export default function rootReducer(history) {
  return combineReducers({
    router: connectRouter(history),
    form: formReducer,
    main,
    // sidebar,
    notifications,
    // popup
  })
}
